import { IconAlertTriangle, IconClipboardList, IconPencil, IconWritingSign } from "@tabler/icons-react";
import { MiniStat } from "./MiniStat";

/** Quick filter opcional activable desde los cards stat (toggle). */
export type QuickFilter = null | "requierenAccion" | "enContabilizacion" | "enAutorizacion" | "enCaptura" | "canceladas";

interface Props {
  /** Conteos calculados por el SERVIDOR sobre el set filtrado COMPLETO (no solo la página visible). */
  total: number;
  enCaptura: number;
  requierenAccion: number;
  enAutorizacion: number;
  /**
   * Quick filter activo · `null` = sin filtro. Si se proveen `quickFilter` +
   * `onQuickFilterChange`, los cards se vuelven clickeables (toggle). Si se
   * omiten, los cards solo muestran info (comportamiento actual del portal).
   */
  quickFilter?: QuickFilter;
  onQuickFilterChange?: (v: QuickFilter) => void;
}

/**
 * Strip de stats arriba de la lista · total, en proceso de captura,
 * rechazos pendientes (resaltado si &gt; 0) y solicitudes en autorización.
 */
export function SolicitudesStats({ total, enCaptura, requierenAccion: rechazoPendiente, enAutorizacion, quickFilter, onQuickFilterChange }: Props) {
  const unidad = (n: number) => (n === 1 ? "Solicitud de pago" : "Solicitudes de pago");

  const handlers = onQuickFilterChange
    ? {
        onTotal: () => onQuickFilterChange(null),
        onRequieren: () => onQuickFilterChange("requierenAccion" as QuickFilter),
        onEnCaptura: () => onQuickFilterChange("enCaptura" as QuickFilter),
        onEnAutorizacion: () => onQuickFilterChange("enAutorizacion" as QuickFilter),
      }
    : undefined;

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <MiniStat
        icon={<IconClipboardList size={16} />}
        label="Total"
        value={total}
        unidad={unidad(total)}
        color="multiva"
        onClick={handlers?.onTotal}
        active={quickFilter === null && !!onQuickFilterChange}
      />
      {/* Los 4 chips UNIFORMES en naranja de marca (opción D · misma
          iteración que los KPIs del dashboard) · la semántica la carga la
          forma del ícono, no el color. */}
      <MiniStat
        icon={<IconPencil size={16} />}
        label="En proceso de captura"
        value={enCaptura}
        unidad={unidad(enCaptura)}
        color="multiva"
        onClick={handlers?.onEnCaptura}
        active={quickFilter === "enCaptura"}
      />
      <MiniStat
        icon={<IconAlertTriangle size={16} />}
        label="Requieren revisión"
        value={rechazoPendiente}
        unidad={unidad(rechazoPendiente)}
        color="multiva"
        onClick={handlers?.onRequieren}
        active={quickFilter === "requierenAccion"}
      />
      <MiniStat
        icon={<IconWritingSign size={16} />}
        label="En autorización"
        value={enAutorizacion}
        unidad={unidad(enAutorizacion)}
        color="multiva"
        onClick={handlers?.onEnAutorizacion}
        active={quickFilter === "enAutorizacion"}
      />
    </div>
  );
}
